import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import { FC, MutableRefObject, useEffect, useMemo, useRef } from 'react';
// eslint-disable-next-line import/no-unresolved
import { Wheel } from 'spin-wheel';

const SpinWheelWrapper = styled.div`
  height: ${Spacings.SPACING_90B};
  width: 90vw;
  overflow: hidden;
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_4B};
`;

export interface SpinWheelItem {
  key: string;
  label: string;
  imageUrl?: string;
  bgColor: string;
}

export interface RewardItem {
  id: number;
  name: string;
  key: string;
  iconImageUrl: string;
}

export interface Event {
  id: number;
  published_at: string;
  eventName: string;
  headerDescription: string;
  primaryColor: string;
  secondaryColor: string;
  descriptionColor: string;
  bgColor: string;
  prizeContainerBgColor: string;
  startDate: string;
  endDate: string;
  ctaButtonText1: string;
  ctaButtonText2: string;
  ctaButtonText3: string;
  ctaButtonText3Link: string;
  bgImageUrl: string;
  headerLogoUrl: string;
  cityStateMapping?: Array<{ state: string; cities: string[] }>;
}

export type PrizeItem = {
  eventIcon: string;
  name: string;
  uid: string;
  prizeIcon: string;
  rank: number;
};

export type UserPrizeDetail = {
  prizeText: string;
  referenceId: string;
  prizeUid: string;
  prizeType: 1 | 2;
};

export interface PrizeDetails {
  userPrizeDetails: UserPrizeDetail;
  prizeItems: PrizeItem[];
}

const SpinWheel: FC<{
  wheelCtxRef: MutableRefObject<any>;
  spinWheelItems: SpinWheelItem[];
  rewardEventDetails: Event;
  onSpinStart: () => void;
  onSpinStop: () => void;
}> = ({
  wheelCtxRef,
  spinWheelItems,
  rewardEventDetails,
  onSpinStart,
  onSpinStop
}) => {
  const wheelContainerRef = useRef<HTMLDivElement>();

  const props = useMemo(() => {
    return {
      items: spinWheelItems.map((item) => {
        return {
          image:
            typeof window !== 'undefined' && item.imageUrl
              ? document.getElementById(`spin-item-${item.key}`)
              : undefined,
          imageRadius: 0.6
        };
      }),
      itemBackgroundColors: spinWheelItems.map((_, index) => {
        const isOddIndex = index % 2 !== 0;
        if (isOddIndex) return rewardEventDetails.primaryColor;
        return rewardEventDetails.secondaryColor;
      }),
      itemLabelFontSizeMax: 40,
      rotationSpeedMax: 1000,
      isInteractive: false,
      lineWidth: 0,
      borderColor: rewardEventDetails.bgColor,
      borderWidth: 6,
      onSpin: () => {
        onSpinStart();
      },
      onRest: () => {
        onSpinStop();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const wheelContainer = wheelContainerRef.current;
    const wheel = new Wheel(wheelContainer, props);
    // eslint-disable-next-line no-param-reassign
    wheelCtxRef.current = wheel;
  }, [props, wheelCtxRef]);

  return (
    <>
      <div style={{ display: 'none' }}>
        {spinWheelItems.map((item) => {
          return (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              key={item.key}
              id={`spin-item-${item.key}`}
              alt={item.label}
              src={item.imageUrl}
              width="105"
              height="100"
            />
          );
        })}
      </div>
      <SpinWheelWrapper ref={wheelContainerRef} />
    </>
  );
};

export default SpinWheel;
